// in src/Dashboard.js
import * as React from "react";
import { Card, CardContent, CardHeader } from '@mui/material';
import { FileInput, FileField, Form, Button, useNotify, useRedirect } from 'react-admin';
import { excel2json } from 'js2excel';
import { httpClient, url_api } from "../constant/constant";

const ExcelImporter = () => {
    const notify = useNotify();
    const redirect = useRedirect();
    const PostSave = (data) => {
        // console.log(data.files.rawFile);
        excel2json([data.files.rawFile], (dat) => {
        // excel2json(list, (dat) => {
            console.log('json', dat["Entri Disini"]);
            httpClient(url_api + "/records/jadwal_piket_ppid", {
                method: 'POST', 
                body: JSON.stringify(dat["Entri Disini"]),
            })
            .then(response=>{
                console.log(response);
                redirect("/jadwal_piket_ppid");
                notify("Import excel jadwal piket sukses")
            })
            .catch((error) => {
                console.error('Error:', error);
                notify(`Terjadi kesalahan, pastikan template isian sudah sesuai! "${error}"`);

            });
        })

    };
    const validateForm = (data) => {
        const errors = {};
        if (!data.files) {
            errors.files = 'Isian file tidak boleh kosong';
        }
        return errors
    };

    return (
            <Form onSubmit={PostSave} validate={validateForm} >
                <FileInput source="files" label=" " placeholder="Drop a .xlsx file to upload, or click to select it." accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                    style={{border: "2px dashed #ccc", borderRadius: "10px"}}
                    sx={{
                        '& .RaFileInput-dropZone': {
                        minHeight: "120px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                        },
                        '& .MuiFormHelperText-root': {
                        color: "red",
                        margin: "0 10px"
                        },
                        
                    }}
                >
                    <FileField source="src" title="title" />
                </FileInput>
                <Button type="submit" variant="contained" label='Submit'/>
            </Form>
    );
};

const PiketPPIDImport = () => (
    <Card style={{marginTop: "20px"}}>
        <CardHeader title="Import jadwal Piket" />
        <CardContent>
            <ExcelImporter/>
        </CardContent>
    </Card>
);

export default PiketPPIDImport;